const u = up.util;
up.LayerStack = class LayerStack {
    constructor() {
        this._currentOverrides = [];
        this.layers = [this._buildRoot()];
    }
    _buildRoot() {
        return up.layer.build({ mode: 'root', stack: this });
    }
    remove(layer) {
        u.remove(this.layers, layer);
    }
    peel(layer, options = {}) {
        var _a;
        const descendants = layer.descendants.toReversed();
        const closeOptions = Object.assign(Object.assign({}, options), { preventable: false });
        const closeMethod = options.intent === 'accept' ? 'accept' : 'dismiss';
        const closeValue = (_a = options.value) !== null && _a !== void 0 ? _a : ':peel';
        for (let descendant of descendants) {
            descendant[closeMethod](closeValue, closeOptions);
        }
    }
    reset() {
        this.peel(this.root, { animation: false });
        this._currentOverrides = [];
        this.root.reset();
    }
    parentOf(layer) {
        return this.layers[layer.index - 1];
    }
    childOf(layer) {
        return this.layers[layer.index + 1];
    }
    ancestorsOf(layer) {
        return this.layers.slice(0, layer.index).toReversed();
    }
    selfAndAncestorsOf(layer) {
        return [layer, ...layer.ancestors];
    }
    descendantsOf(layer) {
        return this.layers.slice(layer.index + 1);
    }
    isRoot(layer) {
        return this.root === layer;
    }
    isOverlay(layer) {
        return this.root !== layer;
    }
    isCurrent(layer) {
        return this.current === layer;
    }
    isFront(layer) {
        return this.front === layer;
    }
    get(...args) {
        return this.getAll(...args)[0];
    }
    getAll(...args) {
        return up.LayerLookup.all(this, ...args);
    }
    sync() {
        for (let layer of this.layers) {
            layer.sync();
        }
    }
    asCurrent(layer, fn) {
        try {
            this._currentOverrides.push(layer);
            return fn();
        }
        finally {
            this._currentOverrides.pop();
        }
    }
    reversed() {
        return this.layers.toReversed();
    }
    dismissOverlays(value = null, options = {}) {
        options.dismissible = false;
        for (let overlay of this.overlays.toReversed()) {
            overlay.dismiss(value, options);
        }
    }
    at(index) {
        return this.layers[index];
    }
    indexOf(layer) {
        return this.layers.indexOf(layer);
    }
    get count() {
        return this.layers.length;
    }
    get root() {
        return this.layers[0];
    }
    get overlays() {
        return this.root.descendants;
    }
    get current() {
        return u.last(this._currentOverrides) || this.front;
    }
    get front() {
        return u.last(this.layers);
    }
};
